import {http} from '@/utils';
import {AgentInfoExtra, InviteRechargeRule} from './agent.type';
import {AgentLevelTeamInfoRes, AgentRebateInfoRes} from './type';

// 获取代理额外信息
export function getAgentInfoExtra() {
  return http.post<null, AgentInfoExtra>('app/agent/getAgentInfoExtra');
}

// 获取邀请充值奖励规则详情
export function getRuleDetail() {
  return http.post<null, InviteRechargeRule[]>('app/inviteRecharge/ruleDetail');
}

// 代理中心 - 团队信息
export function getAgentLevelTeamInfo() {
  return http.post<null, AgentLevelTeamInfoRes>(
    'app/agent/agent/level/team/info',
  );
}

// 代理中心 - 返佣比例信息
export function getAgentRebateInfo() {
  return http.post<null, AgentRebateInfoRes>('app/agent/agent/rebate/info');
}
